import { motion } from "framer-motion";
import { MessageCircle, Map } from "lucide-react";
import { WA_DEFAULT, wa } from "../lib/site";

export default function FloatingUI() {
  return (
    <>
      <motion.a
        href={WA_DEFAULT}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Falar com o Magnus no WhatsApp"
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 2, type: "spring", stiffness: 200, damping: 15 }}
        className="fixed bottom-24 md:bottom-8 right-5 md:right-8 z-50 grid place-items-center w-14 h-14 rounded-full bg-whatsapp text-white shadow-2xl shadow-whatsapp/40"
      >
        <span className="absolute inset-0 rounded-full bg-whatsapp animate-pulse-ring" />
        <MessageCircle size={24} className="relative" />
      </motion.a>

      <div className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white/90 backdrop-blur-md border-t border-brand/10 grid grid-cols-2" data-testid="mobile-bottom-bar">
        <a
          href={WA_DEFAULT}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bar-whatsapp"
          className="flex items-center justify-center gap-2 py-4 text-[13px] font-bold text-white bg-whatsapp"
        >
          <MessageCircle size={16} />
          WhatsApp
        </a>
        <a
          href={wa("Olá, Magnus! Quero planejar minha viagem para Foz do Iguaçu.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bar-planejar"
          className="flex items-center justify-center gap-2 py-4 text-[13px] font-bold text-white bg-brand"
        >
          <Map size={16} />
          Planejar viagem
        </a>
      </div>
    </>
  );
}
